module.exports = __webpack_public_path__ + "static/video-hosting-161aba617c4dcfd8a220d84955614b21.png";